import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import api from "../../api/axios";

export default function useProductHook(props) {
  const queryClient = useQueryClient();
  const search = props?.search;
  const { data: Products, isLoading: ProductsLoading } = useQuery({
    queryKey: ["ProductList", search],
    queryFn: async () => {
      const res = await api.get("products/list", { params: { search } });
      return res.data;
    },
    networkMode: "always", // always fetch from the server

    retry: false, // don't retry if request fails
  });
  const submitProductMutation = useMutation({
    mutationFn: async (productData) => {
      const res = await api.post("/products/add-product/", productData, {
        headers: { "Content-Type": "application/json" },
      });
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["productList"]);
    },
  });

  const updateProductMutation = useMutation({
    mutationFn: async ({ uuid, productData }) => {
      const res = await api.put(`/products/edit/${uuid}/`, productData, {
        headers: { "Content-Type": "application/json" },
      });
      return res.data;
    },
    onSuccess: (data, variables, context) => {
      // window.location.reload();
      context.queryClient.invalidateQueries(["productList", "product_fetch"]);
    },
  });
  const FetchSingleProduct = (uuid) => {
    const { data: Product, isLoading: ProductLoading } = useQuery({
      queryKey: ["Product_fetch", uuid],
      queryFn: async () => {
        const res = await api.get(`/products/${uuid}/`);
        return res.data;
      },
      enabled: !!uuid, // only run if uuid is provided
      retry: false,
    });
    return { Product, ProductLoading };
  };

  const submitProductLoading = submitProductMutation.isLoading;

  return {
    Products,
    ProductsLoading,
    submitProductMutation,
    submitProductLoading,
    FetchSingleProduct,
    updateProductMutation,
  };
}
